import React from "react"

const Info = ({ content }) => {
  return (
    <React.Fragment>
      <div className="container mx-auto my-5">
        <h2 className="text-center display-4">About Habitat Hills</h2>
        <p className="text-muted lead w-75 text-center mx-auto">{content}</p>
      </div>
    </React.Fragment>
  )
}

Info.defaultProps = {
  content: `A resort made with beautiful natural nuances green scenery, fresh air, the sound of gurgling water and the chirping of birds will always be around you. Located on 27 hectares area, it is a perfect choice for you who like nature and want to escape the hustle and bustle of Jakarta.`,
}

export default Info
